/**
 * Объект с названиями хедеров для обмена с бэком по апи.
 */
export const headerNames = {
    TOKEN: 'X-Token',
};
